import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${({ height }) =>
    height
      ? `calc(100% - ${viewSizeCalculator(height)})`
      : `calc(100% - ${viewSizeCalculator(7.7)})`};
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem

  padding: ${() => `0 ${viewSizeCalculator(1.25)}`}; // 0.625rem
`;
